import { Indicator } from '../../../Common/Charts/Indicator';
import { useSchedulingChartsDataContext } from './hooks/useSchedulingChartsDataContext';

export const AppointmentsBalance = () => {
    const { chartData } = useSchedulingChartsDataContext();


    return (
        <Indicator
            title={'Percentual do Saldo'}
            indicatorValue={chartData?.indicators?.balancePercentage}
            height={300}
        />
    );
};
